type ImageSource = 'sentinel1' | 'sentinel2';
export type EOBrowserService = 'sentinelhub' | 'copernicus';

interface SentinelHubUrlParams {
    date: string;
    lat: number;
    lng: number;
    imageSource: ImageSource;
    service: EOBrowserService;
    zoom: number;
}

interface ServiceConfig {
    baseUrl: string;
    getDatasetId: (imageSource: ImageSource) => string;
    getLayerId?: (imageSource: ImageSource) => string;
}

const EOBrowserServiceConfig: Record<EOBrowserService, ServiceConfig> = {
    sentinelhub: {
        baseUrl: 'apps.sentinel-hub.com/eo-browser',
        getDatasetId: (source) =>
            ({
                sentinel1: 'S1_AWS_IW_VVVH',
                sentinel2: 'S2L1C',
            }[source]),
    },
    copernicus: {
        baseUrl: 'browser.dataspace.copernicus.eu',
        getDatasetId: (source) =>
            ({
                sentinel1: 'S1_CDAS_IW_VVVH',
                sentinel2: 'S2_L1C_CDAS',
            }[source]),
        getLayerId: (source) =>
            ({
                sentinel1: 'IW-DV-VH-LINEAR-GAMMA0-ORTHORECTIFIED',
                sentinel2: '1_TRUE_COLOR',
            }[source]),
    },
};

export const getEOBrowserUrl = ({ date, lat, lng, imageSource, service, zoom }: SentinelHubUrlParams): string => {
    const startOfDate = new Date(`${date}T00:00:00Z`).toISOString();
    const endOfDate = new Date(`${date}T23:59:59Z`).toISOString();

    const config = EOBrowserServiceConfig[service];
    const datasetId = config.getDatasetId(imageSource);
    const layerId = config.getLayerId?.(imageSource);

    return (
        `https://${config.baseUrl}/` +
        `?zoom=${zoom}` +
        `&lat=${lat}` +
        `&lng=${lng}` +
        `&datasetId=${datasetId}` +
        (layerId ? `&layerId=${layerId}` : '') +
        `&fromTime=${startOfDate}` +
        `&toTime=${endOfDate}`
    );
};
